import React from 'react';
import styled from 'styled-components';
// import posed from 'react-pose';
// import { tween } from 'popmotion';

const AnimatedHexagon = (props) => {
  const { pose, poseProps } = props;

  // const HexagonAnimation = posed.div({
  //   disable: {
  //     // scale: poseProps.initial_scale,
  //   },
  //   enable: {
  //     // scale: poseProps.gain_scale,
  //   },
  // });

  // const StyledHexagon = styled(HexagonAnimation)`
  const StyledHexagon = styled.div`
    position: relative;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    z-index: 0;
    width: 100%;
  `;

  return (
    <StyledHexagon pose={pose}>
      {props.children}
    </StyledHexagon>
  );
};

const AnimatedContainer = (props) => {
  const { pose, poseProps } = props;

  // const HexagonAnimation = posed.div({
  //   disable: {
  //     transform: poseProps.traslate_to,
  //     transition: teste => tween({ ...teste, duration: poseProps.duration_go }),
  //   },
  //   enable: {
  //     transform: poseProps.traslate_from,
  //     transition: teste => tween({ ...teste, duration: poseProps.duration_back }),
  //   },
  // });

  // const StyledContainer = styled(HexagonAnimation)`
  const StyledContainer = styled.div`
    position: relative;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    z-index: 0;
    width: ${poseProps.width_hexagon};
    transform: ${poseProps.traslate_from};
  `;

  return (
    <StyledContainer pose={pose}>
      {props.children}
    </StyledContainer>
  );
};

export const Animated = (props) => {
  const { pose, poseProps } = props;
  return (
    <AnimatedContainer
      pose={pose}
      poseProps={poseProps}
    >
      <AnimatedHexagon
        pose={pose}
        poseProps={poseProps}
      >
        {props.children}
      </AnimatedHexagon>
    </AnimatedContainer>
  );
};

export default Animated;



// WEBPACK FOOTER //
// ./src/components/UI/Animations/HeroHexagons/hexagonPoses.jsx